const heroI18n = {
  "fr": {
    "hero": {
      "title": {
        "l1": "Écrans & pièces détachées,",
        "l2": "vendez en toute confiance."
      },
      "subtitle": "Bénéficiez d’un service clair et professionnel : estimation rapide, suivi logistique transparent et paiement sécurisé après vérification de vos produits.",
      "cta": "Vendre maintenant !",
      "alt": {
        "brokenIphone": "iPhone cassé"
      }
    }
  },
  "en": {
    "hero": {
      "title": {
        "l1": "Screens & spare parts,",
        "l2": "sell with confidence."
      },
      "subtitle": "Enjoy a clear and professional service: fast estimates, transparent shipping tracking, and secure payment after your items are checked.",
      "cta": "Sell now!",
      "alt": {
        "brokenIphone": "Broken iPhone"
      }
    }
  },
  "pl": {
    "hero": {
      "title": {
        "l1": "Ekrany i części zamienne,",
        "l2": "sprzedawaj z pewnością."
      },
      "subtitle": "Skorzystaj z przejrzystej i profesjonalnej usługi: szybka wycena, śledzenie przesyłki i bezpieczna płatność po weryfikacji produktów.",
      "cta": "Sprzedaj teraz!",
      "alt": {
        "brokenIphone": "Uszkodzony iPhone"
      }
    }
  },
  "es": {
    "hero": {
      "title": {
        "l1": "Pantallas y piezas de repuesto,",
        "l2": "vende con total confianza."
      },
      "subtitle": "Disfruta de un servicio claro y profesional: estimación rápida, seguimiento logístico transparente y pago seguro tras la verificación de tus productos.",
      "cta": "¡Vender ahora!",
      "alt": {
        "brokenIphone": "iPhone roto"
      }
    }
  },
  "it": {
    "hero": {
      "title": {
        "l1": "Schermi e pezzi di ricambio,",
        "l2": "vendere con fiducia."
      },
      "subtitle": "Godetevi un servizio chiaro e professionale: preventivi veloci, tracciamento della spedizione trasparente e pagamento sicuro dopo che i vostri articoli sono controllati.",
      "cta": "Vendi subito!",
      "alt": {
        "brokenIphone": "iPhone rotto"
      }
    }
  },
  "de": {
    "hero": {
      "title": {
        "l1": "Bildschirme und Ersatzteile,",
        "l2": "Verkaufen mit Vertrauen."
      },
      "subtitle": "Genießen Sie einen klaren und professionellen Service: schnelle Schätzungen, transparente Versandverfolgung und sichere Zahlung, nachdem Ihre Artikel überprüft wurden.",
      "cta": "Jetzt verkaufen!",
      "alt": {
        "brokenIphone": "Zerbrochenes iPhone"
      }
    }
  },
  "pt": {
    "hero": {
      "title": {
        "l1": "Ecrãs e peças de reposição,",
        "l2": "vender com confiança."
      },
      "subtitle": "Desfrute de um serviço claro e profissional: estimativas rápidas, rastreamento de transporte transparente e pagamento seguro após seus itens serem verificados.",
      "cta": "Vende agora!",
      "alt": {
        "brokenIphone": "iPhone quebrado"
      }
    }
  },
  "cs": {
    "hero": {
      "title": {
        "l1": "obrazovky a náhradní díly,",
        "l2": "prodávat s důvěrou."
      },
      "subtitle": "Užijte si jasnou a profesionální službu: rychlé odhady, transparentní sledování přepravy, a bezpečná platba po kontrole vašich položek.",
      "cta": "Prodej to hned!",
      "alt": {
        "brokenIphone": "Zlomený iPhone"
      }
    }
  },
  "nl": {
    "hero": {
      "title": {
        "l1": "Scherm & reserveonderdelen,",
        "l2": "Verkoop met vertrouwen."
      },
      "subtitle": "Geniet van een duidelijke en professionele service: snelle schattingen, transparante verzending volgen, en veilige betaling na uw items worden gecontroleerd.",
      "cta": "Verkoop nu!",
      "alt": {
        "brokenIphone": "Gebroken iPhone"
      }
    }
  }
};

export default heroI18n;
